import { combineReducers } from 'redux';

import {
    REQUEST_UPDATE_PROFILE,
    SUCCESS_UPDATE_PROFILE,
    FAILURE_UPDATE_PROFILE,
    RESET_FORM_SUBMIT_UPDATE_PROFILE,
    SET_TIMEOUT_ID,
    CLEAR_TIMEOUT_ID
} from './constants';

const successProfileUpdateRequestSubmit = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_UPDATE_PROFILE:
            return true;
        case REQUEST_UPDATE_PROFILE:
        case FAILURE_UPDATE_PROFILE:
        case RESET_FORM_SUBMIT_UPDATE_PROFILE:
            return false;
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_UPDATE_PROFILE:
            return true;
        case FAILURE_UPDATE_PROFILE:
        case SUCCESS_UPDATE_PROFILE:
        case RESET_FORM_SUBMIT_UPDATE_PROFILE:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_UPDATE_PROFILE:
            return action.response.message;
        case REQUEST_UPDATE_PROFILE:
        case SUCCESS_UPDATE_PROFILE:
        case RESET_FORM_SUBMIT_UPDATE_PROFILE:
            return '';
        default:
            return state;
    }
};

const status = (state = 0, action) => {
    switch (action.type) {
        case FAILURE_UPDATE_PROFILE:
        case SUCCESS_UPDATE_PROFILE:
            return action.response.status;
        case REQUEST_UPDATE_PROFILE:
        case RESET_FORM_SUBMIT_UPDATE_PROFILE:
            return 0;
        default:
            return state;
    }
};

const resetTimeoutId = (state = -1, action) => {
    switch (action.type) {
        case SET_TIMEOUT_ID:
            return action.timeoutId;
        case CLEAR_TIMEOUT_ID:
        case RESET_FORM_SUBMIT_UPDATE_PROFILE:
            return -1;
        default:
            return state;
    }
};

export default combineReducers({
    successProfileUpdateRequestSubmit,
    fetching,
    error,
    status,
    resetTimeoutId
});



// WEBPACK FOOTER //
// ./src/services/account/myprofile/reducer.js